import React from 'react';
export function ProductSection() {
  return <div className="bg-cream border border-border py-11 px-10 my-11 text-center rounded-[3px] max-[600px]:py-8 max-[600px]:px-[22px]" data-id="element-19">
      <span className="font-inter text-[11px] tracking-[0.18em] uppercase text-teal mb-3.5 block font-semibold" data-id="element-20">
        The Formula I Used
      </span>
      <h3 className="font-lora text-[clamp(24px,3.5vw,32px)] font-bold text-black mb-4 leading-[1.25]" data-id="element-21">
        Lumé Vitality For Women
      </h3>
      <p className="font-lora text-[17px] text-[#222222] max-w-[480px] mx-auto mb-8 font-normal leading-[1.8]" data-id="element-22">
        The 7-herb formula rooted in Chinese medicine that finally addressed
        what my four doctors never could. Not a hormone replacement. Not a
        band-aid. A complete system designed to restore the balance
        perimenopause takes away.
      </p>

      <div className="flex items-center gap-4 bg-white border border-border py-[18px] px-[22px] mx-auto mb-7 max-w-[460px] text-left rounded-[3px] max-[600px]:flex-col max-[600px]:text-center" data-id="element-23">
        <div className="w-[46px] h-[46px] bg-teal rounded-full flex items-center justify-center shrink-0 text-white text-[20px]" data-id="element-24">
          ✓
        </div>
        <p className="font-inter text-[13px] leading-[1.5] text-[#111111] m-0" data-id="element-25">
          <strong className="block font-lora text-[15px] text-black mb-[3px] font-bold" data-id="element-26">
            60-Day Relief Guarantee
          </strong>
          If you don't feel a genuine difference - better sleep, fewer hot
          flashes, more stable mood - you pay nothing. No questions asked.
        </p>
      </div>

      <a href="https://trylumevitality.com/products/lumevitality" className="inline-block bg-teal text-white no-underline py-[18px] px-11 font-inter text-[16px] font-semibold tracking-[0.03em] rounded-[3px] transition-all duration-150 hover:bg-teal-dark hover:-translate-y-px w-full max-w-[420px]" data-id="element-27">
        See the full formula and try it risk free →
      </a>
      <span className="font-inter text-[12px] text-[#555555] mt-3 block" data-id="element-28">
        Free shipping &nbsp;·&nbsp; Cancel anytime &nbsp;·&nbsp; 60-day money
        back guarantee
      </span>
    </div>;
}